import { render, staticRenderFns } from "./RegisterVue.vue?vue&type=template&id=a8d0e938&scoped=true"
import script from "./RegisterVue.vue?vue&type=script&lang=js"
export * from "./RegisterVue.vue?vue&type=script&lang=js"
import style0 from "./RegisterVue.vue?vue&type=style&index=0&id=a8d0e938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d0e938",
  null
  
)

export default component.exports